var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitoring-wrap"},[_c('template-search-read',{attrs:{"readApi":_vm.readApi,"reload":_vm.reload},on:{"button":_vm.button,"searchFilter":_vm.getSearchFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }